import MoreVertIcon from '@material-ui/icons/MoreVert';
import React from 'react';

export function MoreIcon({disabled = false}) {
  return <MoreVertIcon fontSize="small" color={disabled ? 'disabled' : 'primary'} />;
}
